import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
import { TIPO_NOTIFICACION,TIPO_PERFIL } from "@/constantes/usuarios.js";
const db = firebase.firestore()

const store = {
  state: {
    vencimientos: [],
  },
  getters: {
    vencimientos: state => {
      return state.vencimientos
    },
  },
  mutations: {
    ASIGNA_VENCIMIENTOS(state, vencimientos) {
      state.vencimientos = vencimientos
    },
  },
  actions: {

    cargarVencimientos({ commit, getters }, fecha) {
      return new Promise((resolve,reject) => {
        let start = new Date(fecha.fecha_inicio);


        var end = new Date(fecha.fecha_fin);
        end.setHours(23);
        end.setMinutes(59); // timestamp
        end = new Date(end); // Date object HORA:60 EXACTAMENTE
  
        //if (cargadorReportes === null) {
          //console.log('ENTRO A CARGAR REPORTES2222')
          db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.SERVICIOS_CASOS)
          .where('servicio_generico.info.fecha_vencimiento', '>', start)
          .where('servicio_generico.info.fecha_vencimiento', '<', end)
          //.where("servicio_generico.activo", "==", true)
          .orderBy("servicio_generico.info.fecha_vencimiento")
          .get().then(doc => {
            var jsonvalue = [];
            doc.forEach(snapshot => {
              if (snapshot.exists) {
                var datos = snapshot.data();
                if(datos.status !== 'Off work' && Object.keys(datos).length!==0) {
                  datos.id = snapshot.id;
                  jsonvalue.push(datos)
                }
              }
            })
            //console.log("Asigna vencimientos ", jsonvalue)
            commit('ASIGNA_VENCIMIENTOS', jsonvalue)
            resolve();
          })
      })
    },
    async enviarVencimientos({dispatch}, data){

      //console.log("Data ", data)
      try{
        for(var i in data){

          console.log(data[i])

          var notificacionPropietario = {
            // Puede ser TIPO_NOTIFICACION.INMEDIATA o TIPO_NOTIFICACION.PROGRAMADA
            tipo: TIPO_NOTIFICACION.INMEDIATA,
            modulo: 'vencimientos',
            info: {
            enviada: false,
            id: data[i].id_propietario,
            // PROPIETARIO  / USUARIO
            perfil: TIPO_PERFIL.PROPIETARIO,
            // Push  / Mail
            tipo: ["Push","Mail"],
            data: {
                asunto: "Recordatorio de tu vencimiento",
                texto:"Estimado "+ data[i].nombre_propietario+" \n"+
                "Te recordamos que "+
                data[i].nombre_paciente+ " tiene pendiente el siguiente servicio: \n"+
                data[i].nombre_servicio+" para el día: "+ data[i].fecha_vencimiento +"\n"+
                "Recuerda que puedes estar al tanto del seguimiento de tu mascota a través de nuestra"+
                "app móvil, descárgala ya",//.\nAtte. Equipo de Pixan Cloud.",
                contenido:"Estimado "+ data[i].nombre_propietario+" <br>"+
                "Te recordamos que <strong>"+
                data[i].nombre_paciente+ "</strong> tiene pendiente el siguiente servicio: <br>"+
                data[i].nombre_servicio+" para el día: "+ data[i].fecha_vencimiento +"<br>"+
                "Recuerda que puedes estar al tanto del seguimiento de tu mascota a través de nuestra"+
                "app móvil, descárgala ya."//\nAtte. Equipo de Pixan Cloud."
                }
            }
          }

          //console.log("Envia notificacion ", notificacionPropietario)
          
          await dispatch('actualizarEstatusServicioCaso',data[i].id)
          await dispatch('enviarNTF', notificacionPropietario)
        }
        return true;
      }catch(error){
        return error;
      }
    }
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/vencimientos/vencimientos.js